/* global _ angular swal */

import './style.less';

export default function($log, $q, $state, $stateParams, Swal, CategoryClass, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.formData = {};
  vm.certificatesActive = !!$stateParams.eventid;
  vm.editActive = !$stateParams.eventid;
  vm.activeTab = $stateParams.tab || 'info';
  vm.certForm = {};

  vm.edit = () => (vm.editActive = false);

  vm.submit = employees => {
    if ((vm.certForm && !vm.certForm.$valid) || !vm.formData.event_id) {
      return Swal.alert('Hold Up!', 'Please fill out and submit all required event information.', 'warning');
    }

    return ApiClass.eventsIdTypePut(
      { id: vm.formData.event_id, type: 'certs' },
      { certs: buildCerts(employees) },
      { queryParams: { manage: true } }
    )
      .then(activate)
      .then(() => {
        employees.length = 0;
        Swal.toast('Certificates Added!');
        vm.activeTab = 'certificates';
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = true;
        throw error;
      });
  };

  vm.setState = index => $state.transitionTo($state.current, { ...$stateParams, tab: index }, { notify: false });

  function buildCerts(employees) {
    return employees.map(({ company_id, email, first, formData, last, profile_uid }) => {
      return {
        company_id,
        email,
        first,
        hours: formData.hours,
        hours_basic: formData.hours_basic,
        last,
        profile_uid,
        delivery_method: formData.delivery_method
      };
    });
  }

  function activate() {
    vm.error = {};

    $log.debug('RUNNING USER CERTS CONTROLLER');
    const qArr = [CategoryClass.loadCategories()];
    if (!$stateParams.eventid) qArr.push($q.resolve({ data: false }));
    else qArr.push(ApiClass.eventsIdGet({ id: $stateParams.eventid }, {}, { queryParams: { manage: true } }));

    return $q
      .all(qArr)
      .then(([categories, { data }]) => {
        vm.categoriesDict = categories.obj;
        if (data) vm.formData = data.event;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/external/index.js